export class UpdatePasswordDTO {
  public oldPassword: string;

  public password: string;
}

